// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__dYhLx"};